import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationServiceProviderSearchCriteria extends ModelBase {
    public organisationName: string = "";

    public serviceProviderName: string = "";
}